import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { Button } from "bootstrap-4-react/lib/components";
import {
    getAllBarCodeType,
    getBarcodeSize,
    getShippingLabelPreferenceDetails,
    updateShippingLabelPreferenceDetails,
} from "../../../store/actions/barcode.action";
import { toast } from "react-toastify";
import LoaderSpinner from "../../common/Loader";
import { orderBarCodeList } from "../../../constant";

/* istanbul ignore next */
const OrderLabelBarcodeSetting = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [error, setErrors] = useState({});
    const [formData, setFormData] = useState({});
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        dispatch(getAllBarCodeType());
        dispatch(getBarcodeSize({}));
        getShippingLabelSettingDetails();
    }, []);

    const validateForm = () => {
        let isValid = true;
        let errorData = {};
        if (!formData.width) {
            isValid = false;
            errorData.width = "This is required";
        }
        if (!formData.height) {
            isValid = false;
            errorData.height = "This is required";
        }
        setErrors(errorData);
        return isValid;
    };

    const handleChange = (e, type = "") => {
        let { value, name } = e.target;
        setFormData({ ...formData, [name]: type ? Number(value) || null : value });
        setErrors({ ...error, [name]: "" });
    };

    const getShippingLabelSettingDetails = async () => {
        let response = await getShippingLabelPreferenceDetails();
        if (response?.data?.Status === 200) {
            setFormData(response.data.Entity);
        } else {
            toast.error(response.data.Message.AppStatusDescription || "Something went wrong");
            return null;
        }
    };

    const handleSaveSettings = async () => {
        try {
            if (validateForm()) {
                setLoader(true);
                let payload = {
                    barCodeText: Number(formData.barCodeText),
                    barCodeTitle: Number(formData.barCodeTitle),
                    subTitle: Number(formData.subTitle),
                    width: Number(formData.width),
                    height: Number(formData.height),
                    fileAction: Number(formData.fileAction),
                    id: formData.id,
                };
                const createBarCodeRes = await updateShippingLabelPreferenceDetails(payload);

                if (createBarCodeRes.data && createBarCodeRes.data.Status === 200) {
                    toast.success('Saved successfully');
                    navigate("/barcode");
                } else {
                    toast.error('Something went wrong');
                }
                setLoader(false);
            } else {
                toast.error('Validation failed');
            }
        } catch (error) {
            console.error("Error Saving settings:", error);
        }
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec custitle">
                    <div>Order Label Barcode Setting</div>
                    <div className="top_right_button_container">
                        <Button
                            className="cus-seconday-bg-btn top-btn"
                            id="savesr"
                            onClick={handleSaveSettings}
                            disabled={loader}
                        >
                            Save Settings
                        </Button>
                        <Button
                            className="cus-primary-transparent-btn"
                            onClick={() => {
                                navigate("/barcode");
                            }}
                            disabled={loader}
                        >
                            Back
                        </Button>
                    </div>
                </div>
                {loader && <LoaderSpinner />}
                <div className="main_content cus-page-content-sec incomingTbl">
                    <div className="top_right_button_container cus-content-only-sec">
                        <div className="incoming_wrapper addressDetailWrapper fontFix">
                            <div className="row">
                                <div className="col-lg-4 col-sm-12 col-md-12 mobMb-10">
                                    <div>Barcode Text Box <span className="require-field">*</span></div>                                    
                                    <select
                                        className="selectInput form-control"
                                        value={formData.barCodeText}
                                        name="barCodeText"
                                        onChange={(e) => handleChange(e)}
                                        disabled
                                    >
                                        {orderBarCodeList?.length > 0 && orderBarCodeList.map((option) => (
                                            <option
                                                value={option.id}
                                                key={option.id}
                                                disabled={option.isDisabled}
                                            >
                                                {option.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-4 col-sm-12 col-md-12 mobMb-10">
                                    <div>Barcode Title</div>
                                    <select
                                        className="selectInput form-control"
                                        value={formData.barCodeTitle}
                                        name="barCodeTitle"
                                        onChange={(e) => handleChange(e)}
                                    >
                                        {orderBarCodeList?.length > 0 && orderBarCodeList.map((option) => (
                                            <option
                                                value={option.id}
                                                key={option.id}
                                                disabled={option.isDisabled}
                                            >
                                                {option.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-3 col-lg-4 mobMb-10">
                                    <div>Sub Title</div>
                                    <select
                                        className="selectInput form-control"
                                        value={formData.subTitle}
                                        name="subTitle"
                                        onChange={(e) => handleChange(e)}
                                    >
                                        {orderBarCodeList?.length > 0 && orderBarCodeList.map((option) => (
                                            <option
                                                value={option.id}
                                                key={option.id}
                                                disabled={option.isDisabled}
                                            >
                                                {option.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-lg-3 col-lg-8 mobMbTop-10">
                                    <div className="row">
                                        <div className="col-4">
                                            <div>
                                                Width <span className="error">*</span>
                                            </div>
                                            <input
                                                className="form-control"
                                                type="number"
                                                name="width"
                                                value={formData.width}
                                                min={0}
                                                onChange={(e) => handleChange(e, "num")}
                                                onKeyDown={(evt) =>
                                                    ["e", "E", "+", "-"].includes(evt.key) &&
                                                    evt.preventDefault()
                                                }
                                            />
                                            <p className="error dialogError">{error.width}</p>
                                        </div>
                                        <div className="col-1 alignEnd alignCenter">X</div>
                                        <div className="col-4">
                                            <div>
                                                Height <span className="error">*</span>
                                            </div>
                                            <input
                                                className="form-control"
                                                type="number"
                                                name="height"
                                                value={formData.height}
                                                min={0}
                                                onChange={(e) => handleChange(e, "num")}
                                                onKeyDown={(evt) =>
                                                    ["e", "E", "+", "-"].includes(evt.key) &&
                                                    evt.preventDefault()
                                                }
                                            />
                                            <p className="error dialogError">{error.height}</p>
                                        </div>
                                        <div className="col-2 alignEnd">Inches</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-lg-9">
                                    <fieldset
                                        id="fileAction"
                                        className="codeOptions codeOptions-mob-res"
                                        onChange={(e) => handleChange(e, "num")}
                                    >
                                        <div className="col col-md-12 col-sm-12">
                                            <input
                                                type="radio"
                                                value={1}
                                                checked={Number(formData.fileAction) === 1}
                                                name="fileAction"
                                                id="savePdf"
                                            />{" "}
                                            <label htmlFor="savePdf">Save as Pdf</label>
                                        </div>
                                        <div className="col col-md-12 col-sm-12">
                                            <input
                                                type="radio"
                                                value={2}
                                                checked={Number(formData.fileAction) === 2}
                                                name="fileAction"
                                                id="print"
                                            />{" "}
                                            <label htmlFor="print">Print</label>
                                        </div>
                                        <div className="col col-md-12 col-sm-12">
                                            <input
                                                type="radio"
                                                value={3}
                                                checked={Number(formData.fileAction) === 3}
                                                name="fileAction"
                                                id="savePrint"
                                            />{" "}
                                            <label htmlFor="savePrint">Save and Print</label>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};
export default OrderLabelBarcodeSetting;
